import React from "react";
import { Link } from "react-router-dom";
import logo from "../assets/svgs/adoptzi_logo.svg";
import logoGreen from "../assets/svgs/adoptzi_green_logo.svg";

function Navbar(props) {
  let hasOptions = () => {
    const customClassesDef = props.customClasses ? true : false;
    if (customClassesDef) {
      return props.customClasses.indexOf("no-options") === -1;
    }

    return true;
  };

  return (
    <div
      className={`navbar${
        typeof props.whiteVersion !== "undefined" && props.whiteVersion === true
          ? " navbar--white"
          : ""
      }${props.customClasses ? " " + props.customClasses : ""}`}
    >
      <div className={"navbar__wrapper"}>
        <Link to={"/"}>
          {typeof props.whiteVersion === "undefined" && (
            <img src={logo} alt={"Adoptzi Logo"} />
          )}
          {typeof props.whiteVersion !== "undefined" &&
            props.whiteVersion === true && (
              <img src={logoGreen} alt={"Adoptzi Logo"} />
            )}
        </Link>
        {/* {hasOptions() ? (
          <div className={"navbar__hambur"}>Test</div>
        ) : (
          <React.Fragment></React.Fragment>
        )} */}
        {hasOptions() ? (
          <div className={"navbar__options"}>{props.children}</div>
        ) : (
          <React.Fragment></React.Fragment>
        )}
      </div>
    </div>
  );
}

export default Navbar;
